import Vue from 'vue'
import axios from 'axios'
import Element from 'element-ui'
import cookie from '@/common/Cookie'
import hasPermission from '@/common/hasPermission'
import ElDisplay from '@/components/Display'
import ElDictionary from '@/components/Dictionary'
import ElView from '@/components/View'
import ElPanel from '@/components/Panel'
import ElModal from '@/components/Modal'
import Toolbar from '@/components/Toolbar'
import ImageUpload from '@/components/ImageUpload'
import SelectTree from '@/components/SelectTree'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/iconfont/index.css'
import '@/styles/index.scss'
import router from '@/router'
import store from '@/store'

Vue.use(hasPermission)
Vue.use(Element)

Vue.component('el-view', ElView)
Vue.component('el-panel', ElPanel)
Vue.component('el-modal', ElModal)
Vue.component('el-display', ElDisplay)
Vue.component('el-toolbar', Toolbar)
Vue.component('el-image-upload', ImageUpload)
Vue.component('el-dictionary', ElDictionary)
Vue.component('el-select-tree', SelectTree)

Vue.prototype.$http = axios
Vue.http = axios

Vue.prototype.$cookie = cookie
Vue.cookie = cookie

// 设置配置
Vue.config.productionTip = false

// http request 拦截器
// 如果cookie中存在access_token，则更新token
if (Vue.cookie.get('access_token')) {
  store.commit('SET_TOKEN', Vue.cookie.get('access_token'))
}

// 设置默认超时时间2分钟
axios.defaults.timeout = 1000 * 60 * 2

axios.interceptors.request.use(config => {
  if (store.state.token != null) {
    config.headers['Authorization'] = 'Bearer ' + store.state.token
  } else {
    delete config.headers['Authorization']
  }

  return config
}, error => {
  debugger
  Promise.reject(error)
})

// http response 拦截器
axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    let result = {
      error: {
        code: 'timeout',
        message: error.message
      }
    }
    return Promise.reject(result)
  }
  if (error.response) {
    switch (error.response.status) {
      case 401:
        router.replace({
          path: '/signin',
          query: { redirect: router.currentRoute.fullPath }
        })
        break
      case 403:
        router.replace({
          path: '/signin',
          query: { redirect: router.currentRoute.fullPath }
        })
        break
    }
    return Promise.reject(error.response)
  }
  return Promise.reject(error)
})

// 路由配置
router.beforeEach((to, from, next) => {
  if (to.meta.protected && store.state.token === null) {
    next('/signin')
  } else if (to.meta.protected && store.state.identity === null) {
    next('/signin')
  } else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/init/index.js